import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { Build } from "@mui/icons-material";
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { USED_PARTS_ENDPOINT } from '../../../../consts';
import styles from './usedParts.module.css';
import { useHasPermission } from '../../../../contexts/auth';
import { formatDateTimeBadge } from '../../../../utils';

export const UsedParts = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const canViewUsedParts = useHasPermission("service.view_usedpart");

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "job__number",
      headerName: t("Job"),
      editable: false,
      valueGetter: (value, row) => row.job_info?.number || "-",
    },
    {
      field: "ordered_part__number",
      headerName: t("Ordered Part"),
      editable: false,
      valueGetter: (value, row) => row.ordered_part_number || "-",
    },
    {
      field: "quantity",
      headerName: t("Quantity"),
      type: "number",
    },
    {
      field: "total",
      headerName: t("Total"),
      type: "number",
    },
    {
      field: "created_at",
      headerName: t("Created at"),
      renderCell: (params) => formatDateTimeBadge(params.value) || "-",
    },
    {
      field: "updated_at",
      headerName: t("Updated at"),
      renderCell: (params) => formatDateTimeBadge(params.value) || "-",
    },
  ];

  const handleRowClick = (usedPartId: string) => {
    navigate(`/service/stock-status/${id}/used-parts/${usedPartId}`);
  };

  if (!canViewUsedParts) {
    return null;
  }

  // Filter used parts by part ID through ordered_part relationship
  const usedPartsUrl = id ? `${USED_PARTS_ENDPOINT}?part=${id}` : USED_PARTS_ENDPOINT;

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<Build />}
        title={t('Used Parts')}
        url={usedPartsUrl}
        gridSettingsKey="USED_PARTS"
        columns={columns}
        refreshEventName="usedPartAdded"
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
